import { I18nFormatterFunctionType } from './i18n-formatter.type';

export const unityFormatter: I18nFormatterFunctionType = (
  value: string,
): string => (value !== '-' ? value : '');
